module.exports = __webpack_public_path__ + "static/media/video-thumbnail.f03f140f.png";